/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomationFeePercentageCondition
 */
export interface AutomationFeePercentageCondition {
    /**
     * 
     * @type {string}
     * @memberof AutomationFeePercentageCondition
     */
    field: AutomationFeePercentageConditionFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof AutomationFeePercentageCondition
     */
    operator: AutomationFeePercentageConditionOperatorEnum;
    /**
     * PA fee percentage to compare against (0–100).
     * @type {number}
     * @memberof AutomationFeePercentageCondition
     */
    value: number;
}


/**
 * @export
 */
export const AutomationFeePercentageConditionFieldEnum = {
    FeePercentage: 'feePercentage'
} as const;
export type AutomationFeePercentageConditionFieldEnum = typeof AutomationFeePercentageConditionFieldEnum[keyof typeof AutomationFeePercentageConditionFieldEnum];

/**
 * @export
 */
export const AutomationFeePercentageConditionOperatorEnum = {
    Eq: 'eq',
    Neq: 'neq',
    Gt: 'gt',
    Lt: 'lt'
} as const;
export type AutomationFeePercentageConditionOperatorEnum = typeof AutomationFeePercentageConditionOperatorEnum[keyof typeof AutomationFeePercentageConditionOperatorEnum];


/**
 * Check if a given object implements the AutomationFeePercentageCondition interface.
 */
export function instanceOfAutomationFeePercentageCondition(value: object): value is AutomationFeePercentageCondition {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('operator' in value) || value['operator'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function AutomationFeePercentageConditionFromJSON(json: any): AutomationFeePercentageCondition {
    return AutomationFeePercentageConditionFromJSONTyped(json, false);
}

export function AutomationFeePercentageConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationFeePercentageCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'operator': json['operator'],
        'value': json['value'],
    };
}

export function AutomationFeePercentageConditionToJSON(json: any): AutomationFeePercentageCondition {
    return AutomationFeePercentageConditionToJSONTyped(json, false);
}

export function AutomationFeePercentageConditionToJSONTyped(value?: AutomationFeePercentageCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'operator': value['operator'],
        'value': value['value'],
    };
}

